import { ClientSettings } from '../types/clientSettings';
import { http, boolHttp } from './http';
import {
  GetClientSettingsUrl,
  GetClientSettingUrl,
  PostClientSettingsUrl,
  PutClientSettingsUrl,
  DeleteClientSettingsUrl,
} from './urls';

interface ClientSettingsDto {
  id: number;
  mask: string | null;
  metadata: {
    devBuild: boolean;
    firstBoosterTutorialLevel: number;
    firstPurchaseTutorialLevel: number;
    challengeTutorialLevel: number;
    noAds: boolean;
    adsFirstLevel: number;
    interstitialEveryLevel: number;
    noPurchase: boolean;
    dailyBonusEnabled: boolean;
    dailyBonusRewardAmount: number;
    wordDescriptionEnabled: boolean;
    missedWordReportEnabled: boolean;
  };
}

const convertFromDto = (dto: ClientSettingsDto): ClientSettings => ({
  id: dto.id,
  mask: dto.mask ?? null,
  metadata: dto.metadata,
});

const convertToDto = (settings: ClientSettings): ClientSettingsDto => ({
  ...settings,
  mask: settings.mask ?? null,
});

const getById = async (id: number): Promise<ClientSettings> => {
  const req = new Request(GetClientSettingUrl(id), { method: 'GET' });
  const dto = await http<ClientSettingsDto>(req);
  return convertFromDto(dto);
};

const ClientSettingsService = {
  getAll: async (): Promise<ClientSettings[]> => {
    const req = new Request(GetClientSettingsUrl(), { method: 'GET' });
    const dtos = await http<ClientSettingsDto[]>(req);
    return dtos.map(convertFromDto);
  },

  getById,

  create: async (clientSettings: ClientSettings): Promise<ClientSettings> => {
    const dto = convertToDto(clientSettings);
    const req = new Request(PostClientSettingsUrl(), {
      method: 'POST',
      body: JSON.stringify(dto),
    });
    const result = await http<ClientSettingsDto>(req);
    return convertFromDto(result);
  },

  update: async (clientSettings: ClientSettings): Promise<ClientSettings> => {
    const dto = convertToDto(clientSettings);
    const req = new Request(PutClientSettingsUrl(), {
      method: 'PUT',
      body: JSON.stringify(dto),
    });
    const result = await http<ClientSettingsDto>(req);
    return convertFromDto(result);
  },

  delete: async (id: number): Promise<boolean> => {
    const req = new Request(DeleteClientSettingsUrl(id), { method: 'DELETE' });
    return await boolHttp(req);
  },
};

export default ClientSettingsService;
